import { render, staticRenderFns } from "./Sidebar-login.vue?vue&type=template&id=0d286b92&"
import script from "./Sidebar-login.vue?vue&type=script&lang=js&"
export * from "./Sidebar-login.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports